export function formatDate(value?: string | null, timezone?: string) {
  if (!value) return 'Não informado'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value
  return new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short', timeStyle: 'short', timeZone: timezone }).format(date)
}

export function formatMoney(amountCents: number, currency: string) {
  try { return new Intl.NumberFormat('pt-BR', { style: 'currency', currency }).format(amountCents / 100) }
  catch { return `${currency} ${(amountCents / 100).toFixed(2)}` }
}

export function formatBytes(value?: number | null) {
  if (value == null) return 'Não definido'
  if (value < 1024) return `${value} B`
  const units = ['KB', 'MB', 'GB', 'TB']
  let size = value / 1024; let unit = units[0]
  for (let index = 1; index < units.length && size >= 1024; index += 1) { size /= 1024; unit = units[index] }
  return `${new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 1 }).format(size)} ${unit}`
}

export function queryString(params: URLSearchParams) {
  const value = params.toString()
  return value ? `?${value}` : ''
}

export function idempotencyKey(prefix: string) {
  return `${prefix}-${crypto.randomUUID()}`
}
